import React from 'react'
import './Footer.css'
import alleghenyBadgers from '../../components/images/alleghenyBadgers.png'

const Footer = () => {
	return (
		<div style={{ backgroundColor: '#89292a' }}>
			{/* <footer className='footerStyle'> */}
			<footer>
				<div>
					<div className='row'>
						<div className='col text-center'>
							{/* <h1
								className='font-weight-light text-capitalize p-3'
								style={{ color: 'white', textShadow: '2px 2px 2px #000000' }}
							>
								Allegheny Badgers
							</h1> */}
							<div>
								<img src={alleghenyBadgers} className='sssLogo' />
							</div>
							<h4
								className='font-weight-bold font-italic'
								style={{ color: 'white', textShadow: '2px 2px 2px #000000' }}
							>
								Est. 1992
							</h4>
							<div className='py-3'>
								<a
									href='https://www.facebook.com/AHABadgers/'
									target='_blank'
									style={{ color: 'white' }}
								>
									<i className='fab fa-facebook fa-3x mx-3'></i>
								</a>
							</div>
							<p
								className='py-4 m-0 copyright'
								style={{ color: 'white', backgroundColor: '#686868' }}
							>
								A Web Application by{' '}
								<a
									//href='https://www.shireystatsandstandings.com/#'
									href='https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'
									target='_blank'
									style={{ color: 'white' }}
								>
									Shirey Stats and Standings, LLC
								</a>
							</p>
							<p
								className='m-0 copyright'
								style={{
									paddingTop: '0rem',
									paddingBottom: '1rem',
									color: 'white',
									backgroundColor: '#686868',
								}}
							>
								<a
									href='https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'
									target='_blank'
									style={{ color: 'white' }}
								>
									Now on the App Store!
								</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
